import $ from 'jquery';

if ($('.accordion__header').length) {
  $(document).on('click', '.accordion__header', (event) => {
    const $accordionHeader = $(event.currentTarget);
    const $accordionParent = $(event.currentTarget).parent();
    const $allAccordionWrapper = $('.accordion--shadow');
    const $accordionItem = $(event.currentTarget).parent().parent();
    const $nextAccordionItem = $accordionItem.next();
    const elHasActiveShadow = $accordionParent.hasClass('accordion--shadow');

    if (elHasActiveShadow) {
      $allAccordionWrapper.removeClass('accordion--shadow');
      $('.prev-sibling-open').removeClass('prev-sibling-open');
    } else {
      $allAccordionWrapper.removeClass('accordion--shadow');
      $accordionHeader.parent().addClass('accordion--shadow');
      $nextAccordionItem.addClass('prev-sibling-open');
    }
  });
}
